import CryptoJS from 'crypto-js';

export const decrypt = (encryptedText, base64DecryptionKey) =>
  CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Base64.parse(base64DecryptionKey), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })?.toString(CryptoJS.enc.Utf8);

export default {
  decrypt,
};
